import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { Author } from "./author";
import { ChatMedia } from "./chat-media";
import { Host } from "./host";
import { PollCandidate } from "./poll-candidate";
import { PollFinish } from "./poll-finish";
import { TrackLink } from "./track-link";
import { enumValue, AccessLevel, PollStatus, ProfileType } from "./enums";

export class PollDataAnswer {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.textAnswer = asString(json.textAnswer);
    this.candidate = PollCandidate.fromJson(json.candidate);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PollDataAnswer(json) : json;
  }
}

export class PollData {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.totalPollQuestions = asNumber(json.totalPollQuestions);
    this.totalAnswered = asNumber(json.totalAnswered ?? json.totalAnswer);
    this.totalCandidate = asNumber(json.totalCandidate);
    this.answered = asBoolean(json.answered ?? json.anwsered);
    this.pollQuestionId = asString(json.pollQuestionId);
    this.pollQuestion = asString(json.pollQuestion);
    this.totalWinners = asNumber(json.totalWinners);
    this.totalParticipants = asNumber(json.totalParticipants);
    this.pollFinish = asBoolean(json.pollFinish);
    this.answer = PollDataAnswer.fromJson(json.answer ?? json.anwser);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PollData(json) : json;
  }
}

export class Poll {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.systemRemove = asBoolean(json.systemRemove);
    this.archive = asBoolean(json.archive);
    this.itemEdited = asBoolean(json.itemEdited);
    this.pollType = asString(json.pollType);
    this.pollId = asString(json.pollId);
    this.name = asString(json.name);
    this.profileId = asString(json.profileId);
    this.profileType = enumValue(ProfileType, json.profileType);
    this.profileIdentifier = asString(json.profileIdentifier);
    this.host = Host.fromJson(json.host);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.status = enumValue(PollStatus, json.status);
    this.description = asString(json.description);
    this.accessLevel = enumValue(AccessLevel, json.accessLevel);
    this.startDate = asDate(json.startDate);
    this.endDate = asDate(json.endDate);
    this.checkSum = asString(json.checkSum);
    this.author = Author.fromJson(json.author);
    this.createdAt = asDate(json.createdAt);
    this.updatedAt = asDate(json.updatedAt);
    this.totalParticipant = asNumber(json.totalParticipant);
    this.groupId = asString(json.groupId);
    this.groupName = asString(json.groupName);
    this.publishStartDate = asDate(json.publishStartDate);
    this.publishEndDate = asDate(json.publishEndDate);
    this.isLocked = asBoolean(json.isLocked);
    this.pin = asString(json.pin);
    this.media = parseList(json.media, ChatMedia.fromJson);
    this.trackLink = parseList(json.trackLink, TrackLink.fromJson);
    this.pollFinish = PollFinish.fromJson(json.pollFinish);
  }

  get isActive() {
    return this.status === PollStatus.ACTIVE;
  }

  get isInactive() {
    return this.status === PollStatus.INACTIVE;
  }

  get isPublished() {
    return this.status === PollStatus.PUBLISH;
  }

  get isCancelled() {
    return this.status === PollStatus.CANCELLED;
  }

  get isClosed() {
    return this.status === PollStatus.CLOSE;
  }

  static fromJson(json: any) {
    return isObject(json) ? new Poll(json) : json;
  }
}
